import { apiClient } from '../lib/apiClient';

/**
 * In-app news for the signed-in user (header icon → "Neuigkeiten" dialog;
 * backend src/routes/meReleaseNotes.routes.ts):
 *   GET  /api/v1/me/release-notes       → { data: InAppNews }
 *   POST /api/v1/me/release-notes/seen  → { data: { seen: true } }
 * Texts exist in German and English only; every other locale reads English.
 */
export interface InAppNewsNote {
  id: string;
  version: string;
  appVersion: string | null;
  date: string;
  titleDe: string;
  bodyDe: string;
  titleEn: string;
  bodyEn: string;
  /** Published after the user last opened the dialog. */
  isNew: boolean;
}

export interface InAppNews {
  notes: InAppNewsNote[];
  unread: boolean;
}

export const NEWS_QUERY_KEY = ['me', 'release-notes'] as const;

export async function fetchInAppNews(): Promise<InAppNews> {
  const res = await apiClient.get<{ data: InAppNews }>('/api/v1/me/release-notes');
  return res.data;
}

export async function markInAppNewsSeen(): Promise<void> {
  await apiClient.post('/api/v1/me/release-notes/seen');
}

/** Language of the note text for a UI locale: German for de, English otherwise. */
export function newsLanguage(locale: string): 'de' | 'en' {
  return locale.toLowerCase().startsWith('de') ? 'de' : 'en';
}
